'use client';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translations
import enCommon from '@/locales/en/common.json';
import enNavigation from '@/locales/en/navigation.json';
import enSettings from '@/locales/en/settings.json';
import enHome from '@/locales/en/home.json';
import enSchedule from '@/locales/en/schedule.json';
import enCustomers from '@/locales/en/customers.json';
import enInventory from '@/locales/en/inventory.json';
import enAuth from '@/locales/en/auth.json';
import enAutomations from '@/locales/en/automations.json';
import enInbox from '@/locales/en/inbox.json';
import enSales from '@/locales/en/sales.json';
import enChat from '@/locales/en/chat.json';
import enQueue from '@/locales/en/queue.json';
import enExpenses from '@/locales/en/expenses.json';

// Import Arabic translations
import arCommon from '@/locales/ar/common.json';
import arNavigation from '@/locales/ar/navigation.json';
import arSettings from '@/locales/ar/settings.json';
import arHome from '@/locales/ar/home.json';
import arSchedule from '@/locales/ar/schedule.json';
import arCustomers from '@/locales/ar/customers.json';
import arInventory from '@/locales/ar/inventory.json';
import arAuth from '@/locales/ar/auth.json';
import arAutomations from '@/locales/ar/automations.json';
import arInbox from '@/locales/ar/inbox.json';
import arSales from '@/locales/ar/sales.json';
import arChat from '@/locales/ar/chat.json';
import arQueue from '@/locales/ar/queue.json';
import arExpenses from '@/locales/ar/expenses.json';

// Get initial language from localStorage (client-side only)
const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('language');
    if (stored === 'ar' || stored === 'en') {
      return stored;
    }
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      navigation: enNavigation,
      settings: enSettings,
      home: enHome,
      schedule: enSchedule,
      customers: enCustomers,
      inventory: enInventory,
      auth: enAuth,
      automations: enAutomations,
      inbox: enInbox,
      sales: enSales,
      chat: enChat,
      queue: enQueue,
      expenses: enExpenses,
    },
    ar: {
      common: arCommon,
      navigation: arNavigation,
      settings: arSettings,
      home: arHome,
      schedule: arSchedule,
      customers: arCustomers,
      inventory: arInventory,
      auth: arAuth,
      automations: arAutomations,
      inbox: arInbox,
      sales: arSales,
      chat: arChat,
      queue: arQueue,
      expenses: arExpenses,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  ns: ['common', 'navigation', 'settings', 'home', 'schedule', 'customers', 'inventory', 'auth', 'automations', 'inbox', 'sales', 'chat', 'queue', 'expenses'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false, // React already handles escaping
  },
  react: {
    useSuspense: false, // Disable suspense for SSR compatibility
  },
});

export default i18n;
